import { useEffect } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";

const RenderTopNotificationBannerOverlayApp = (props) => {
  const topBannerDiv = document.getElementById("top-banner-container");
  const mainAppDiv = document.getElementById("root");
  const { show, children } = props;

  useEffect(() => {
    if (show) {
      mainAppDiv.classList.add("main-app-container");
      topBannerDiv.classList.add("top-banner");
    }
    return () => {
      mainAppDiv.classList.remove("main-app-container");
      topBannerDiv.classList.remove("top-banner");
    };
  }, [mainAppDiv, show, topBannerDiv]);

  if (!show) return null;

  return createPortal(children, topBannerDiv);
};

RenderTopNotificationBannerOverlayApp.propTypes = {
  show: PropTypes.bool,
};

RenderTopNotificationBannerOverlayApp.defaultProps = {
  show: false,
};

export default RenderTopNotificationBannerOverlayApp;
